<slick-dialog [resizable]="false" key="DIALOG_STRIKES" header="Marks" width="550" #strikesDialog>
    <marks-edit [appointmentId]="appointmentId" (onSave)="closeDialog()" (onCancel)="closeDialog()"></marks-edit>
</slick-dialog>
